import { Component, Output, EventEmitter, Input } from '@angular/core';

// export enum KEY_CODE {
//   RIGHT_ARROW = 39,
//   LEFT_ARROW = 37,
//   ESCAPE = 27
// }

@Component({
  selector: 'app-gtoolbarcompo',
  templateUrl: './gtoolbarcompo.component.html',
  styleUrls: ['./gtoolbarcompo.component.css'],

})
export class GtoolbarcompoComponent {
  @Output() actionPerformed: EventEmitter<any>;
  @Input() config: GToolbarConfig;
  @Input() reqInProcess: boolean;

  // dropdownId = newId();

  // @HostListener('window:keyup', ['$event'])
  // keyEvent(event: KeyboardEvent) {
  //   console.log(event);

  //   if (event.keyCode === KEY_CODE.ESCAPE) {
  //     // this.decrement();
  //     console.log('hey its working');
  //   }
  // }

  constructor() {
    this.actionPerformed = new EventEmitter();
  }

  PerformSaveAction(val) {
    this.actionPerformed.emit(val);
    // this.config = true;
  }
}



// @Injectable({
//   providedIn: 'root'
// })
export class GToolbarConfig {
  public enableSave: boolean;
  public enableUpdate: boolean;
  public enableDelete: boolean;
  public enableReset: boolean;
  public enablePrint: boolean;
  public enableExit: boolean;
}
